import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { acceptInvite } from "../../api/client";
import { errorMessage } from "../../lib/format";
import type { AuthStage, Session } from "../../platform/firebase";

/** Opened from the link in the backend log: sign in with Google, then redeem it. */
export function InvitePage(props: { session: Session; stage: AuthStage; firebaseEmail: string | null }) {
  const { token = "" } = useParams();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const redeemed = useRef(false);

  useEffect(() => {
    if (props.stage !== "signedIn" || redeemed.current || !token) return;
    redeemed.current = true;
    setBusy(true);
    acceptInvite(token)
      .then(() => window.location.assign("/"))
      .catch((e) => {
        setError(errorMessage(e));
        setBusy(false);
      });
  }, [props.stage, token]);

  const signIn = async () => {
    setError(null);
    try {
      await props.session.signInWithGoogle();
    } catch (e) {
      setError(errorMessage(e));
    }
  };

  return (
    <main className="login">
      <h1>golden</h1>
      <p className="muted">You were invited to review scans.</p>
      {props.stage === "signedIn" ? (
        <p className="muted">{busy ? `Joining as ${props.firebaseEmail ?? "…"}…` : props.firebaseEmail}</p>
      ) : (
        <p>
          <button type="button" className="button" onClick={signIn} disabled={props.stage === "restoring"}>
            Sign in with Google to join
          </button>
        </p>
      )}
      {error && <p className="error">{error}</p>}
    </main>
  );
}
